import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import RolesAndPermissionsPicker from '../../../rolesAndPermissionsPicker/RolesAndPermissionsPicker';

const EditUserDialog = ({ user, onSubmit, onClose }) => {
    const [selectedRoleId, setSelectedRoleId] = useState(user.roleId);
    const [selectedPermissions, setSelectedPermissions] = useState(user.permissions.map(({ id }) => ({ id })));
    const [name, setName] = useState(user.name ?? '');

    const handleSubmit = () => {
        onSubmit({
            name,
            roleId: selectedRoleId,
            permissions: selectedPermissions
        });
    };

    return (
        <Dialog onClose={onClose} open={true} maxWidth="md">
            <DialogTitle>Edit User</DialogTitle>
            <DialogContent>
                <FormControl fullWidth>
                    <TextField
                        autoFocus
                        fullwidth
                        variant="outlined"
                        size="small"
                        label="Name"
                        autoComplete="off"
                        value={name}
                        onChange={e => setName(e.target.value)}
                    />
                </FormControl>
                <Typography gutterBottom>
                    Change the role of <strong>{user.emailAddress}</strong>.
                </Typography>
                <RolesAndPermissionsPicker
                    selectedRoleId={selectedRoleId}
                    selectedPermissions={selectedPermissions}
                    setSelectedRoleId={setSelectedRoleId}
                    setSelectedPermissions={setSelectedPermissions}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSubmit}>Save</Button>
                <Button variant="outlined" onClick={onClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditUserDialog;